import React, { useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  EditOutlined,
  EyeOutlined,
  LogoutOutlined,
  FileTextOutlined,
  CalendarOutlined,
  TeamOutlined,
  SearchOutlined,
  BellOutlined,
} from "@ant-design/icons";
import {
  Button,
  Layout,
  Menu,
  theme,
  Popover,
  Divider,
  message,
  Input,
  Avatar,
  Badge,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import uselogo from "../../Assets/Dashboardimages/userlogo.png";
import { URL } from "../../helper/Mainurl";
// import TopBar from '../DashboardUtils/TopBar';

//Add this svg
import { ReactComponent as Logo1 } from "../../Assets/TopBarImg/Frame5239.svg";
import { ReactComponent as Logo2 } from "../../Assets/TopBarImg/Frame5240.svg";
import { ReactComponent as Logo3 } from "../../Assets/TopBarImg/Frame5241.svg";
import { ReactComponent as Logo4 } from "../../Assets/TopBarImg/Frame720.svg";

import styled from "@emotion/styled";
import NotificationModal from "../Modals/Header/NotificationModal";
import { useUserInfo } from "../../contexts/userInfo";
import { useNotifications } from "../../contexts/NotificationContext";
// background-color: white;
const TopBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 24px;

  background: #f4f2f9;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 12px 5px;
  }
`;

const SearchContainer = styled.div`
  flex: 1;
  width: 62%;

  .ant-input-affix-wrapper {
    border-radius: 8px;
    height: 40px;
    background-color: white;
    border: none;

    &:hover,
    &:focus {
      background-color: #e5e7eb;
    }
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const LogoWrapper = styled.div`
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 38%;

  svg {
    width: 60px;
    height: 60px;
    cursor: pointer;
    fill: white; // works if SVGs use "fill" and not hardcoded colors
  }
`;

const PageHeader = () => {
  const { userInfo } = useUserInfo();
  const { unreadCount, markNotificationAsRead, notifications } =
    useNotifications();
  // console.log(userInfo?.profile_image);
  const navigate = useNavigate();

  const token = localStorage.getItem("authToken"); // Fetch token correctly

  const [visible, setVisible] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false); // for notification modal

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  const handleLogout = async () => {
    console.log("Token::::::", token);

    try {
      const payload = {
        token: token,
      };

      const response = await fetch(`${URL}/v1/logout`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          Authorization: `Bearer ${token}`, // Sending token as Bearer in headers
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        message.success("Logout successful!");
        localStorage.clear();
        navigate("/");
      } else {
        message.error(data.message || "Logout failed!");
      }
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  const content = (
    <div style={{ width: 200 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
          padding: "5px 10px",
        }}
      >
        <span
          style={{
            color: "#9B51E0",
            borderBottom: "2px solid #9B51E0",
            paddingBottom: 3,
          }}
        >
          Profile
        </span>
        <span>Settings</span>
      </div>
      <Divider style={{ margin: "10px 0" }} />
      <div style={{ padding: "5px 10px", cursor: "pointer" }}>
        <Link to="/profile">
          <EditOutlined style={{ color: "#4EC3E0", paddingRight: "5px" }} />{" "}
          <span style={{ color: "#767A83" }}> Edit Profile</span>
        </Link>
      </div>
      <div style={{ padding: "5px 10px", cursor: "pointer" }}>
        <Link to="/profile">
          <EyeOutlined style={{ color: "#4EC3E0", paddingRight: "5px" }} />
          <span style={{ color: "#767A83" }}> View Profile</span>
        </Link>
      </div>
      <div
        style={{ padding: "5px 10px", cursor: "pointer" }}
        onClick={handleLogout}
      >
        <LogoutOutlined style={{ color: "#4EC3E0", paddingRight: "5px" }} />{" "}
        <span style={{ color: "#767A83" }}>Logout</span>
      </div>
    </div>
  );

  return (
    <div>
      <div>
        <TopBarContainer>
          <SearchContainer>
            <Input
              placeholder="Search Dashboard"
              prefix={
                <SearchOutlined
                  style={{ color: "#9CA3AF", paddingTop: "4px" }}
                />
              }
              bordered={false}
              style={{ display: "none" }}
            />
          </SearchContainer>
          <LogoWrapper>
            {/* <Logo3 /> */}
            <div className="relative">
              <Logo4 onClick={() => setIsModalOpen(true)} />
              {unreadCount > 0 && (
                <span className="note-count absolute -top-1 -right-1 h-4 w-4 bg-red-500 rounded-full text-xs text-white flex items-center justify-center">
                  {unreadCount > 9 ? "9+" : unreadCount}
                </span>
              )}
            </div>
            {/* <Logo2 /> */}
            <Popover
              content={content}
              trigger="click"
              visible={visible}
              onVisibleChange={handleVisibleChange}
              placement="bottomRight"
            >
              {userInfo?.profile_image ? (
                <img
                  src={userInfo.profile_image}
                  alt="Profile"
                  className="profile-avatar"
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    objectFit: "cover",
                    cursor: "pointer",
                    marginBottom: "13px",
                  }}
                />
              ) : (
                <Logo1 style={{ cursor: "pointer" }} />
              )}
            </Popover>
          </LogoWrapper>
        </TopBarContainer>
      </div>
      {/* <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          style={{
            fontSize: '16px',
            width: 64,
            height: 64,
          }}
        /> */}
      {/* Header Modals */}
      {isModalOpen && (
        <NotificationModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

export default PageHeader;
